import { memo as Memo, useState, useCallback, useEffect, Fragment, useMemo } from 'react';
import { isBoolean } from 'lodash';

//* HOC's
import withLanguageContext from '@context/consumerHOC/LanguageConsumer';

//* Helpers
import formValidation from '@helpers/formValidation';

//* Components
import FieldErrorMsg from '@components/global/error/FieldErrorMsg';
import InputLine from '@components/global/SvgComponents/InputLine';
import Text from '@/components/global/Text';

const Textarea = Memo((props) => {
	//! Initial State
	const initialState = useMemo(() => {
		return {
			value: props.value || '',
			count: props.value ? props.value.length : 0,
		};
	}, [props.value]);

	//! States
	const [val, setVal] = useState(initialState);
	const [errorMsg, setErrorMsg] = useState();
	const [activeLine, setActiveLine] = useState(false);

	//! Field Value Change
	const onChange = (e) => {
		const length = e.target.value.length;

		if ((props.required.max && length <= props.required.max) || !props.required.max) {
			validate(e.target.value);
			props.onChange && props.onChange(props.name, e.target.value);
			setVal({ value: e.target.value, count: length });
		}
	};

	//! Validate
	const validate = useCallback(
		(newVal) => {
			if (props.realTimeValidate && props.required) {
				const valid = formValidation(newVal, props.type, props.errorMsg, !isBoolean(props.required) && props.required);

				!isBoolean(valid) ? setErrorMsg(valid) : errorMsg && setErrorMsg('');
			}
		},
		[props.realTimeValidate, props.required, props.type, props.errorMsg, props.parentError]
	);

	//! Error Message
	useEffect(() => {
		setErrorMsg(props.errorMsg);
	}, [props.errorMsg]);

	//! Parent Component Reset
	useEffect(() => {
		if (props.parentVal !== val.value) {
			setVal(initialState);
			setErrorMsg('');
		}
	}, [props.parentVal]);

	const ActiveLine = useCallback(() => {
		setActiveLine(true);
		setTimeout(() => {
			setActiveLine(false);
		}, 500);
	}, []);

	//! Checking Placeholder
	const placeholder = useCallback(props.placeholder ? props.translate(props.placeholder) + (props.required ? '*' : '') : '', [props.selectedLang, props.placeholder, props.required]);

	return (
		<Fragment>
			<div className={`textarea-cont ${props.className || ''} ${errorMsg ? 'error' : ''}`}>
				<textarea
					value={val.value}
					onFocus={ActiveLine}
					name={props.name || null}
					placeholder={placeholder}
					onChange={(e) => onChange(e)}
					onKeyDown={(e) => !e.shiftKey && props.keyDown(e)}
				/>

				<InputLine animate={activeLine} />
			</div>

			{props.required.max && (
				<Text
					tag={'span'}
					className='textarea-counter h6'>{`${val.count}/${props.required.max}`}</Text>
			)}

			<FieldErrorMsg msg={props.errorMsg || errorMsg || null} />
		</Fragment>
	);
});

export default withLanguageContext(Textarea, ['translate']);
